import { useState } from "react";
import { SectionUploadCards } from "../../components/TransactionPageComponents/SectionUploadCards/SectionUploadCards";
import { TransactionTypeHeader } from "../../components/TransactionPageComponents/type";
import { TableSwitch } from "../../components/TransactionPageComponents/TableSwitch/TableSwitch";
import { Box } from "../../components/primitives";
import { SectionEditCards } from "../../components/TransactionPageComponents/SectionEditCards/SectionEditCards";
import { SectionSyncCards } from "../../components/TransactionPageComponents/SectionSyncCards/SectionSyncCards";

const TransactionPage = () => {
  const [selected, setSelected] = useState<TransactionTypeHeader>("Uploaded");

  return (
    <Box
      css={{
        backgroundColor: "#f0fdf4",
        minHeight: "100vh",
        paddingBottom: 50,
      }}
    >
      <TableSwitch selected={selected} setSelected={setSelected} />
      {selected === "Uploaded" && <SectionUploadCards />}
      {selected === "Edited" && <SectionEditCards />}
      {selected === "Synced" && <SectionSyncCards />}
    </Box>
  );
};

export default TransactionPage;
